import { useNavigate } from 'react-router-dom'
import img1 from '../../assets/industries/tech1.svg'
import img2 from '../../assets/industries/tech2.svg'

const Technology = () => {

    const navigate = useNavigate()


    return (
        <div className='main-class'>
            <h1
                className='text-xl md:text-2xl font-bold text-center dark:text-white'
            >
                <span className='text-yellow-500'>Entrust Your Technology</span> Development <br /> Needs to CodeZone
            </h1>

            <div className='grid grid-cols-1 md:grid-cols-2 px-3 md:px-0 gap-6 my-6 md:my-14'>
                <div className='bg-gradient-to-r from-red-600 to-red-400 px-4 py-7 flex flex-col md:flex-row items-center rounded-lg gap-4'>
                    <div>
                        <img src={img1} alt='img' className='h-[70px] md:h-[110px] object-contain' />
                    </div>
                    <div className='space-y-3'>
                        <h1 className='text-white font-bold text-sm'>
                            Dedicated Remote Team
                        </h1>
                        <p className='text-white text-xs'>
                            If you’re looking for an offshore development team, this remote model perfectly matches your requirements. Hire a dedicated remote team and get 100% control over your resources.
                        </p>

                        <button
                            onClick={() => navigate('/contact-us')}
                            className=" rounded-xl px-4 py-1 overflow-hidden relative group cursor-pointer border-2 font-semibold text-[14px] md:text-[17px] border-yellow-500 text-black ">
                            <span className="absolute w-64 h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 bg-yellow-500 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
                            <span className="relative text-white transition duration-700 ease">Get in Touch</span>
                        </button>
                    </div>
                </div>
                <div className=' px-4 py-7 flex items-center rounded-lg gap-4 flex-col md:flex-row'>
                    <div>
                        <img src={img2} alt='img' className='h-[70px] md:h-[110px] object-contain' />
                    </div>
                    <div className='space-y-3'>
                        <h1 className=' font-bold text-sm dark:text-white'>
                            Project-Based Model
                        </h1>
                        <p className='text-xs dark:text-white'>
                            Want to focus on business? Hand in your tech development to us. We define expected deliverables and timelines with a fixed budget.                        </p>

                        <button
                            onClick={() => navigate('/contact-us')}
                            className=" rounded-xl px-4 py-1 overflow-hidden relative group cursor-pointer border-2 font-semibold text-[14px] md:text-[17px] border-red-500  ">
                            <span className="absolute w-64 h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 bg-red-500 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
                            <span className="relative text-red-500 transition duration-700 ease group-hover:text-white">Discuss Your Project</span>
                        </button>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Technology